// Constants
import { CONTRACT_TYPE_APPLICATION_PDF } from './constants/contract.handlers.constants';
import {
  AMOUNT,
  FINANCIAL_LIST_PROPS,
  INTERESTS,
  MONTHLY,
  PAYMENT,
  SHIPPING,
  TOTAL,
} from '../constants/contract.constants';
// Types
import {
  ContractHandlersBuilderType,
  ContractHandlersType,
  DowloadDocumentFromUrlHandlerType,
  DowloadDocumentHandlerType,
} from './types/contract.handlers.type';
// Translations
import { PDF_ATTACH } from './translations/contract.handlers.translations';
// Utils
import {
  createTagAndsDispatchFile,
  downloadFileFromUrl,
  isDesktopDevice,
  isIOSDevice,
  isIOSWebview,
} from '@openbank/cf-ui-framework';

const setupFinancialPreContractDataHandler = ({
  flowApiData,
  setFinancialData,
}: ContractHandlersBuilderType): void => {
  if (flowApiData) {
    FINANCIAL_LIST_PROPS[AMOUNT].value = flowApiData.amount;
    FINANCIAL_LIST_PROPS[INTERESTS].value = flowApiData.totalInterestAmount;
    FINANCIAL_LIST_PROPS[INTERESTS].nominalInterest = flowApiData.nominalInterest;
    FINANCIAL_LIST_PROPS[INTERESTS].interestRate = flowApiData.interestRate;
    FINANCIAL_LIST_PROPS[TOTAL].value = flowApiData.totalAmount;
    FINANCIAL_LIST_PROPS[SHIPPING].value = flowApiData.installmentAmount;
    FINANCIAL_LIST_PROPS[MONTHLY].value = flowApiData.installmentAmount;
    FINANCIAL_LIST_PROPS[MONTHLY].installments = flowApiData.installmentsNumber;
    FINANCIAL_LIST_PROPS[PAYMENT].value = flowApiData.paymentMethod;
    FINANCIAL_LIST_PROPS[PAYMENT].accounts = flowApiData?.accounts;
    setFinancialData(FINANCIAL_LIST_PROPS);
  }
};

const downloadDocumentHandler = async ({
  blob,
  formatMessage,
  fileName,
}: DowloadDocumentHandlerType): Promise<void> => {
  if (!isDesktopDevice() && (isIOSWebview() || isIOSDevice())) {
    // Si es tablet o móvil iOS
    const file = new File(
      [blob],
      `${formatMessage({ id: fileName })}.pdf`,
      CONTRACT_TYPE_APPLICATION_PDF
    );

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: `${formatMessage({ id: fileName })}.pdf`,
        text: formatMessage({ id: PDF_ATTACH }),
      });
    } else {
      // Fallback: descarga normal
      createTagAndsDispatchFile({ blob, filename: `${formatMessage({ id: fileName })}.pdf` });
    }
  } else {
    createTagAndsDispatchFile({ blob, filename: `${formatMessage({ id: fileName })}.pdf` });
  }
};

const downloadFromUrlHandler = ({
  url,
  fileName,
  formatMessage,
}: DowloadDocumentFromUrlHandlerType): void => {
  downloadFileFromUrl({ url, filename: `${formatMessage({ id: fileName })}.pdf` });
};

const ContractHandlers = (props: ContractHandlersBuilderType): ContractHandlersType => ({
  handleDownloadDocument: (fileName: string, blob: Blob) =>
    downloadDocumentHandler({
      fileName,
      blob,
      formatMessage: props.formatMessage,
    }),
  handleDownloadFromUrl: (fileName: string, url: string) =>
    downloadFromUrlHandler({ fileName, url, formatMessage: props.formatMessage }),
  handleSetupFinancialContractData: () => setupFinancialPreContractDataHandler(props),
});

export { ContractHandlers };
